import { createFileRoute } from '@tanstack/react-router';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';
import { AiAnalysisDashboard } from '@/features/ai-analysis/AiAnalysisDashboard';
import { defaultPeriod, isValidYmd } from '@/features/ai-analysis/utils/period';

export const Route = createFileRoute('/_authenticated/ai-analysis/')({
  validateSearch: (search: Record<string, unknown>) => {
    const defaults = defaultPeriod();
    return {
      from: isValidYmd(search.from) ? search.from : defaults.from,
      to: isValidYmd(search.to) ? search.to : defaults.to,
    };
  },
  component: AiAnalysisPage,
});

function AiAnalysisPage() {
  return (
    <PermissionGate permission={Permission.AI_ANALYSIS_MANAGE}>
      <AiAnalysisDashboard />
    </PermissionGate>
  );
}
